// extracted by mini-css-extract-plugin
export default {"move-in-right":"_1Z9u8","moveInRight":"_1Z9u8","move-in-left":"_3o45F","moveInLeft":"_3o45F"};